export default "__VITE_ASSET__6a2f063c__"